import { clsx } from 'clsx';
import type { ReactNode } from 'react';
import type {
  ButtonProps as UiButtonProps,
  ButtonVariant,
} from '@agentselly/ui';
import { Button as UiButton } from '@agentselly/ui';

// Dark-Mode-Ergaenzung: nur diese App faehrt `darkMode: 'class'`, deshalb
// liegen die `dark:`-Klassen hier und nicht in der kanonischen Komponente.
const DARK: Record<ButtonVariant, string> = {
  primary: 'dark:bg-primary-600 dark:text-white dark:hover:bg-primary-500',
  secondary:
    'dark:bg-secondary-700 dark:text-white dark:hover:bg-secondary-600',
  outline:
    'dark:border-gray-600 dark:bg-gray-800 dark:text-gray-200 dark:hover:bg-gray-700',
  ghost: 'dark:text-primary-300 dark:hover:bg-gray-800',
};

export interface ButtonProps extends UiButtonProps {
  /** @deprecated Stattdessen `variant="primary"` verwenden. */
  primary?: boolean;
  children: ReactNode;
}

export function Button({ primary, variant, className, ...rest }: ButtonProps) {
  const resolved: ButtonVariant = variant ?? (primary ? 'primary' : 'outline');

  return (
    <UiButton
      {...rest}
      variant={resolved}
      className={clsx('max-w-xs', DARK[resolved], className)}
    />
  );
}
